import React from "react";
import styled from "styled-components";
import i18next from "i18next";
// @ts-ignore
import { CWBModal } from "cwb-react";
import { withI18n } from "react-i18next";
import { Button, ButtonGroup } from "../Common";
// import { default as AlertYellow } from "./../../images/alert-yellow.svg"

const AlertModal = ({
  title,
  message,
  cancelBtnMsg,
  actionBtnMsg,
  closeModal,
  actionBtn,
  icon,
  open,
  width,
  t,
}: any) => {
  const getIcon = () => {
    //let baseUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : "";
    const svgDir = require.context('./../../images/');
    if (icon === "warning" || icon == "warn") {
      return svgDir('./alert-yellow.svg');
    }

    return null;
  };

  // default behavior is open
  let isOpenParam = open;
  if (typeof (open) === "undefined")
    isOpenParam = true;

  let widthParam = width;
  if (!width)
    widthParam = 800;

  return (
    <StyledModal
      $width={widthParam}
      className={"cwb-modal"}
      title={title}
      body={message}
      hideModal={closeModal}
      isOpen={isOpenParam}
      buttons={
        <StyledButtonGroup>
          <Button onClick={actionBtn}>
            <StyledSpan>{actionBtnMsg}</StyledSpan>
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            {cancelBtnMsg}
          </Button>
        </StyledButtonGroup>
      }
    >
      {icon && getIcon() && <StyledImgIcon src={getIcon()} />}
      {message}
    </StyledModal>
  );
};

interface ICustomProps {
  $width: number
}

const StyledModal = styled(CWBModal) <ICustomProps>`
  max-width: ${p => (p.$width || 800)}px !important;
  .modal-body {
    padding: 12px 0 24px 0 !important;
    height: auto !important;
  }

  .modal-content {
    padding-bottom: 20px;
  }
`;

const StyledButtonGroup = styled(ButtonGroup)`
  width: 100%;
`;

const StyledImgIcon = styled.img`
  margin-right: 5px;
  padding-bottom: 5px;
  width: 16px;
`;

const StyledSpan = styled.span`
  display: flex;
  justify-content: center;
  font-size: 14px;
  font-weight: bold;
  & > img {
    margin-left: 4px;
  }
`;

AlertModal.defaultProps = {
  message: i18next.t("Are you sure"),
};

export default withI18n()(AlertModal);
